$(document).ready(function () {
  const $mobileNavDrawer = $('[js-data="mobile-nav-drawer"]')
  $mobileNavDrawer.on('click touchstart', toggleNavDrawer)

  function toggleNavDrawer(e) {
    e.preventDefault()
    const isOpen = $(this).attr('js-drawer-open')
    const navDropdownItem = $(this).siblings('[js-data="mobile-nav-drawer-items"]')[0]
    if (isOpen) {
      $(this).removeAttr('js-drawer-open')
      navDropdownItem.removeAttribute('open')
    } else {
      $(this).attr('js-drawer-open', true)
      navDropdownItem.setAttribute('open', '')

      const $parentElm = $(this).parent()
      const $parentSiblings = $parentElm.siblings()
      toggleOffSiblingDrawers($parentSiblings)
    }
  }

  function toggleOffSiblingDrawers($siblings) {
    
    $siblings.each((index, sibling) => {      
      const $drawer = $(sibling).find('[js-data="mobile-nav-drawer"]')
      const $drawerItems = $(sibling).find('[js-data="mobile-nav-drawer-items"]')
      $drawer.removeAttr('js-drawer-open')
      $drawerItems.removeAttr('open')
    })

  }
})